import React, { FC } from 'react';
import { ToastContentProps } from 'react-toastify';
import { formatTimeSec } from 'services/date';
import classNames from 'classnames';

export type ToastMessageProps = Partial<ToastContentProps> & {
    title?: string;
    message?: string;
    date?: Date;
};

export const ToastMessage: FC<ToastMessageProps> = ({ title, message, date, closeToast, toastProps }) => {
    let toastTitle = title;
    if (!title) {
        switch (toastProps?.type) {
            case 'error':
                toastTitle = 'Error';
                break;

            case 'warning':
                toastTitle = 'Warning';
                break;

            case 'success':
                toastTitle = 'Success';
                break;

            default:
                toastTitle = 'Information';
                break;
        }
    }

    return (
        <div
            className={classNames(
                'toast notification fade show',
                {
                    'notification-danger toast-danger': toastProps?.type === 'error',
                    'notification-info toast-info': toastProps?.type === 'info',
                    'notification-success toast-success': toastProps?.type === 'success',
                    'notification-warning toast-warning': toastProps?.type === 'warning',
                    'notification-primary toast-primary': toastProps?.type === 'default',
                },
            )}
        >
            <div className="notification-header">
                <span className="fw-medium me-auto">{toastTitle}</span>
                <span className="notification-timestamp">
                    {formatTimeSec(date)}
                </span>
                <button type="button" className="btn-close" aria-label="Close" onClick={closeToast} />
            </div>
            {message && <div
                className="notification-body text-primary"
                style={{ whiteSpace: 'pre-line' }}
            >
                <div>{message}</div>
            </div>}
        </div>
    );
};
